import { Button, SimplifiedStepSection } from '@quicktools/shared-components';
import { IStep } from '@quicktools/shared-components/components/landingPages/SimplifiedStepSection';

export interface IHowToSection {
  getStarted: () => void;
  howToSection: {
    title: string;
    steps: [{ title: string; description: string }];
    cta: string;
  };
}

const HowToSection = ({ getStarted, howToSection }: IHowToSection) => {
  const steps: IStep[] = Array.from(Array(3)).map((_, index) => ({
    title: howToSection?.steps[index].title,
    description: howToSection?.steps[index].description,
  }));

  return (
    <SimplifiedStepSection
      cta={<Button onClick={getStarted}>{howToSection?.cta}</Button>}
      title={howToSection?.title}
      steps={steps}
    />
  );
};

export default HowToSection;
